module.exports = __webpack_public_path__ + "img/[米饭].066da641.svg";